import { DayPickerProps, DayPicker } from 'react-day-picker';

import './DayPicker.css';

const StyledDayPicker = (props: DayPickerProps): JSX.Element => (
    <DayPicker weekStartsOn={1} {...props} />
);
export { StyledDayPicker as DayPicker };
